// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__FGXCQ","hero__title":"styles_hero__title__GLE5h"};